import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

let router=new Router({
    mode:"hash", //1、hash哈希：有#号。2、history历史：没有#号
    base:process.env.BASE_URL,
    //记录滚动的位置解决白屏问题，必须配合keep-alive
    scrollBehavior(to,from,position){
        if(position){
            return position
        }else{
            return {x:0,y:0}
        }
    },
    routes:[
        {
            path:"/",
            name:"main",
            component:()=>import("./pages/home/main/index"),
            redirect:"/index",
            children:[
                {
                    path:"index",
                    name:"index",
                    component:()=>import("./pages/home/index/index"),
                    meta:{title:"首页",keepAlive:true,auth:true}
                },
                {
                    path:"test",
                    name:"test",
                    component:()=>import("./pages/home/test/index"),
                    meta:{title:"考试中心",keepAlive:false,auth:true}
                },
                {
                    path:"testDetail",
                    name:"testDetail",
                    component:()=>import("./pages/home/test/testDetail"),
                    meta:{title:"考试详情",keepAlive:false,auth:true}
                },
                {
                    path:"goTest",
                    name:"goTest",
                    component:()=>import("./pages/home/test/goTest"),
                    meta:{title:"考试",keepAlive:false,auth:true}
                },
                {
                    path:"alreadyTest",
                    name:"alreadyTest",
                    component:()=>import("./pages/home/test/alreadyTest"),
                    meta:{title:"已考试",keepAlive:false,auth:true}
                },
                {
                    path:"train",
                    name:"train",
                    component:()=>import("./pages/home/train/index"),
                    meta:{title:"培训中心",keepAlive:false,auth:true}
                },
                {
                    path:"trainDetail",
                    name:"trainDetail",
                    component:()=>import("./pages/home/train/trainDetail"),
                    meta:{title:"培训详情",keepAlive:false,auth:true}
                },
                {
                    path:"alreadyTrain",
                    name:"alreadyTrain",
                    component:()=>import("./pages/home/train/alreadyTrain"),
                    meta:{title:"培训中心",keepAlive:false,auth:true}
                },
                {
                    path:"collect",
                    name:"collect",
                    component:()=>import("./pages/home/collect/index"),
                    meta:{title:"收藏试题",keepAlive:false,auth:true}
                },
                {
                    path:"collectVideo",
                    name:"collectVideo",
                    component:()=>import("./pages/home/collect/collectVideo"),
                    meta:{title:"收藏视频",keepAlive:false,auth:true}
                },
                {
                    path:"mistakes",
                    name:"mistakes",
                    component:()=>import("./pages/home/mistakes/index"),
                    meta:{title:"错题集",keepAlive:false,auth:true}
                },
                {
                    path:"trainRecord",
                    name:"trainRecord",
                    component:()=>import("./pages/home/certificate/trainRecord"),
                    meta:{title:"培训记录",keepAlive:false,auth:true}
                }
                ,
                {
                    path:"trainCert",
                    name:"trainCert",
                    component:()=>import("./pages/home/certificate/trainCert"),
                    meta:{title:"培训证书",keepAlive:false,auth:true}
                },
                {
                    path:"testCert",
                    name:"testCert",
                    component:()=>import("./pages/home/certificate/testCert"),
                    meta:{title:"考试记录",keepAlive:false,auth:true}
                },
                {
                    path:"certificateList",
                    name:"certificateList",
                    component:()=>import("./pages/home/certificate/certificateList"),
                    meta:{title:"证书列表",keepAlive:false,auth:true}
                },
                {
                    path:"trainRank",
                    name:"trainRank",
                    component:()=>import("./pages/home/certificate/trainRank"),
                    meta:{title:"培训时长排行榜",keepAlive:false,auth:true}
                },
                {
                    path:"testRank",
                    name:"testRank",
                    component:()=>import("./pages/home/certificate/testRank"),
                    meta:{title:"考试证书排行榜",keepAlive:false,auth:true}
                }
            ]
        },
        {
            path:"/login",
            name:"login",
            component:()=>import("./pages/home/login/index"),
            meta:{title:"登录",keepAlive:false}
        },
        {
            path:"/bindInfo",
            name:"bindInfo",
            component:()=>import("./pages/home/login/bindInfo"),
            meta:{title:"绑定信息",keepAlive:false}
        },
        {
            path:"/queryCertificate",
            name:"queryCertificate",
            component:()=>import("./pages/home/login/queryCertificate"),
            meta:{title:"查询证书",keepAlive:false}
        },
        {
            path:"/qrCode",
            name:"qrCode",
            component:()=>import("./pages/home/login/qrCode"),
            meta:{title:"扫码登录",keepAlive:false}
        },
        {
            path:"/locking",
            name:"locking",
            component:()=>import("./pages/home/login/locking"),
            meta:{title:"页面锁定",keepAlive:false}
        },
        {
            path:"/help",
            name:"help",
            component:()=>import("./pages/home/help/help"),
            meta:{title:"帮助中心",keepAlive:false}
        },
        {
            path:"/guidance",
            name:"guidance",
            component:()=>import("./pages/home/help/guidance"),
            meta:{title:"操作指导手册",keepAlive:false}
        },
        {
            path:"/guidVideo",
            name:"guidVideo",
            component:()=>import("./pages/home/help/guidVideo"),
            meta:{title:"操作视频",keepAlive:false}
        },
        {
            path:"/skip",
            name:"skip",
            component:()=>import("./pages/skip"),
            meta:{title:"测试",keepAlive:false}
        },
        {
            path:"/preview",
            name:"preview",
            component:()=>import("./pages/home/certificate/preview"),
            meta:{title:"证书预览",keepAlive:false}
        }
    ]
});


export default router;
